import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { WizardLabel, errorStepOne } from "../../Resources/Content";
import { Lightbox, LightboxType } from "../../../../../react-core/Html/Components/Lightbox";
import { DestinationAccountSearchPopup } from "./DestinationAccountSearchPopup";
import { TransferDestinationAccountModel } from "../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { subAccountTypeMap } from "../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/Performance/Resource/Contents";

interface IDestinationAccountProps extends React.Props<DestinationAccount> {
    onChange: (key: string, value: any, data?: any) => void;
    data: TransferDestinationAccountModel;
    isReview: boolean;
    serviceProposition: ServiceProposition;
}
interface IDestinationAccountState {
    isShowPopup: boolean;
    selectAccount: TransferDestinationAccountModel;
}

export class DestinationAccount extends FormComponent<IDestinationAccountProps, IDestinationAccountState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isShowPopup: false,
            selectAccount: this.props.data,
        };
    }

    private onRemove() {
        this.setState({ selectAccount: null });
        this.props.onChange("DestinationClAccountId", null);
    }

    private renderThead(): JSX.Element {
        const titles = Object.values(WizardLabel.desAccountTable);
        if (this.props.data && !this.props.data.Name) {titles[0] = "";}
        return (
            <thead>
                <tr>
                    {titles.map((ele) => {
                        return <th key={ele}>{ele}</th>;
                    })}
                    {!this.props.isReview && (
                        <th>
                            <button
                                disabled={this.props.data ? true : false}
                                className="btn primary"
                                onClick={() => this.setState({ isShowPopup: true })}
                            >
                                {WizardLabel.desAccountPopup.search}
                            </button>
                        </th>
                    )}
                </tr>
            </thead>
        );
    }

    private renderTbody(data: TransferDestinationAccountModel): JSX.Element {
        return (
            <tbody>
                <tr>
                    <td>{data.Name}</td>
                    <td>{data.ClAccountId}</td>
                    <td>{subAccountTypeMap[data.SubAccountType]}</td>
                    <td>{data.ProductDisplayName}</td>
                    {!this.props.isReview && (
                        <td>
                            <button
                                className="remove-button"
                                style={{ textDecoration: "underline", cursor: "pointer" }}
                                onClick={() => this.onRemove()}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                {WizardLabel.desAccountPopup.remove}
                            </button>
                        </td>
                    )}
                </tr>
            </tbody>
        );
    }

    render() {
        const { isShowPopup, selectAccount } = this.state;
        const account = selectAccount || this.props.data;
        return (
            <>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th colSpan={5}>{WizardLabel.desAccountTitle}</th>
                        </tr>
                    </thead>
                    {this.renderThead()}
                    {account ? (
                        this.renderTbody(account)
                    ) : (
                        <tbody className="body-split">
                            <tr className="sub-head">
                                <td colSpan={6}>{errorStepOne.noDesAccount}</td>
                            </tr>
                        </tbody>
                    )}
                </table>
                {isShowPopup && (
                    <Lightbox
                        show={isShowPopup}
                        title={WizardLabel.desAccountPopup.title}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ isShowPopup: false })}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <DestinationAccountSearchPopup
                            selectDesAccount={(acc) => {
                                this.setState({ selectAccount: acc, isShowPopup: false });
                                this.props.onChange("DestinationClAccountId", acc.ClAccountId, acc);
                            }}
                            servicePropostion={this.props.serviceProposition}
                        />
                    </Lightbox>
                )}
            </>
        );
    }
}
